import { render, staticRenderFns } from "./FccSolicitacaoEspecificaTDeficiencia.vue?vue&type=template&id=252e7ef8"
import script from "./FccSolicitacaoEspecificaTDeficiencia.vue?vue&type=script&lang=js"
export * from "./FccSolicitacaoEspecificaTDeficiencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports